import { LAYOUTS, POSITION, } from '@voltmoney/types';
import { IconTokens, SizeTypeTokens, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { ACTION, } from './types';
import { getURL, goBack, leadToPayment, navigation, verifyOtp, needHelp, excessAmountHandleAction, resetPage } from './actions';
import SharedPropsService from '../../../SharedPropsService';
import { api, config } from '../../../configs/api';
import { APP_CONFIG, getAppHeader } from '../../../configs/config';
import { getContactUsDetails, isFromAndroidWebview, removeUrlWithoutReload, showExcessAmountHandling } from '../../../configs/utils';
import { LENDER_ID, QUERY_PARAMS, TARGET_PAGES } from '../../../configs/constants';
import sharedPropsService from "../../../SharedPropsService";
import { Platform } from "react-native";
import { isIframe } from "../../payment/paymentStart/actions";
export const template = (creditStatus, isAllowed, platform, height, creditResponse, creditAmount, sanctionedLimit, totalOutstanding, userData, contactUsDetails, isFromJupiter, showExcessAmountHandlingFlag, isLoanExpired) => {
    return {
        layout: {
            id: ROUTE.OUTSTANDING_DUES,
            type: LAYOUTS.LIST,
            widgets: [
                { id: "manageLimit", type: WIDGET.OUTSTANDING_DUES }
            ],
        },
        datastore: {
            manageLimit: {
                height: height,
                bankData: creditResponse,
                creditLimit: creditAmount,
                backAction: {
                    type: ACTION.MENU,
                    payload: { id: 'bt_outstanding_goBack' },
                    routeId: ROUTE.OUTSTANDING_DUES,
                },
                userData: userData,
                applyAction: {
                    type: ACTION.ENHANCE_LIMIT,
                    routeId: ROUTE.OUTSTANDING_DUES,
                    payload: { creditResponse }
                },
                continuePress: {
                    routeId: ROUTE.FORECLOSURE,
                    type: ACTION.MARGIN_CALL,
                    payload: {}
                },
                excessAmountHandleAction: {
                    type: ACTION.EXCESS_AMOUNT_HANDLE,
                    routeId: ROUTE.OUTSTANDING_DUES,
                    payload: { id: 'bt_whatever' }
                },
                sanctionedAmount: sanctionedLimit,
                totalOutstanding: totalOutstanding,
                needHelp: {
                    routeId: ROUTE.FORECLOSURE,
                    type: ACTION.NEED_HELP,
                    payload: { id: 'bt_outstanding_needHelp' }
                },
                excessAmountLoader: false,
                contactUsDetails: contactUsDetails,
                isFromJupiter: isFromJupiter,
                showExcessAmountHandlingFlag: showExcessAmountHandlingFlag,
                isLoanExpired,
            }
        },
    };
};
export const outstandingDues = {
    onLoad: async ({ getHeight, instrumentTrack, setDatastore, navigate, goBack, showPopup, appendWidgets, removeWidgets, network }, { target, restartPayment }) => {
        if (restartPayment) {
            const userContextResponse = await network.post(api.userContext, {}, { headers: await getAppHeader() });
            const userCreditId = userContextResponse.data.linkedCredits[0].creditId;
            var popupWindow;
            let tataFlag = false;
            const lenderAccountId = userContextResponse?.data?.linkedCredits[0]?.lendingPartnerId;
            if (lenderAccountId.toLowerCase() !== LENDER_ID.DSP.toLowerCase()) {
                if (lenderAccountId.toLowerCase() === LENDER_ID.TATA.toLowerCase()) {
                    const accountId = userContextResponse?.data.linkedApplications[0].accountId;
                    const response = await network.get(`${api.isTataMergerEnabled}${accountId}`, { headers: await getAppHeader() });
                    tataFlag = response?.data?.isEnabled;
                }
                await setDatastore(ROUTE.OUTSTANDING_DUES, "manageLimit", {
                    loading: true
                });
                await network.post(`${api.requestForeclosureCollection}`, {
                    baseOriginUrl: `${config.APP_URL}`,
                    creditId: userCreditId,
                    redirect: Platform.OS === 'web' && !isIframe() && !isFromAndroidWebview() ? true : false
                }, { headers: await getAppHeader() })
                    .then(res => {
                    if (res.status === 200) {
                        const isFromTata = userContextResponse.data.linkedCredits[0].lendingPartnerId = "Tata";
                        if (Platform.OS !== 'web') {
                            // appendWidgets(
                            //     ROUTE.PAYMENT_START,
                            //     {
                            //         repayLoanWebView: <WebViewProps>{
                            //             iframe: false,
                            //             uri: res.data.paymentLink
                            //         },
                            //         keyboardSpace: <SpaceProps>{size: SizeTypeTokens.XXXXXXL},
                            //         keyboardSpace2: <SpaceProps>{size: SizeTypeTokens.XXXXXXL},
                            //         keyboardSpace3: <SpaceProps>{size: SizeTypeTokens.XXXXXXL},
                            //     },
                            //     [
                            //         {id: "repayLoanWebView", type: WIDGET.WEB_VIEW},
                            //         {id: "keyboardSpace", type: WIDGET.SPACE},
                            //         {id: "keyboardSpace2", type: WIDGET.SPACE},
                            //         {id: "keyboardSpace3", type: WIDGET.SPACE},
                            //     ],
                            //     "header"
                            // );
                            removeWidgets(ROUTE.PAYMENT_START, [
                                {
                                    id: "manageLimit",
                                    type: WIDGET.OUTSTANDING_DUES,
                                },
                                {
                                    id: "spaceLG",
                                    type: WIDGET.SPACE
                                },
                                {
                                    id: "titleStack",
                                    type: WIDGET.STACK,
                                },
                                {
                                    id: "spaceXXXL",
                                    type: WIDGET.SPACE
                                },
                                {
                                    id: "selectFullAmountStack",
                                    type: WIDGET.STACK
                                },
                                {
                                    id: "spaceXXXL",
                                    type: WIDGET.SPACE
                                },
                                {
                                    id: "divider",
                                    type: WIDGET.DIVIDER
                                },
                                {
                                    id: "partialAmountFullStack",
                                    type: WIDGET.STACK
                                },
                                {
                                    id: "proceedButtonStack",
                                    type: WIDGET.STACK,
                                    position: POSITION.ABSOLUTE_BOTTOM
                                },
                                {
                                    id: "spaceLG",
                                    type: WIDGET.SPACE
                                },
                                { id: "enterAmountFullStack", type: WIDGET.STACK },
                                { id: "amountMessage", type: WIDGET.TEXT }
                            ]);
                            setDatastore(ROUTE.OUTSTANDING_DUES, "header", {
                                title: (isFromTata)
                                    ? (tataFlag
                                        ? "Paying to Tata Capital Limited"
                                        : "Paying to Tata Capital Financial Services Ltd.")
                                    : "Paying to Bajaj Finance"
                            });
                            const runPollar = async () => {
                                network.get(`${api.userPaymentData}${res.data.collectionId}`, { headers: await getAppHeader(), routeName: "PAYMENT_START" }).then((response) => {
                                    if (response.data.collectionStatus !== 'REQUESTED') {
                                        clearInterval(timer);
                                        removeWidgets(ROUTE.PAYMENT_START, [
                                            { id: "repayLoanWebView", type: WIDGET.WEB_VIEW },
                                            { id: "keyboardSpace", type: WIDGET.SPACE },
                                            { id: "keyboardSpace2", type: WIDGET.SPACE },
                                            { id: "keyboardSpace3", type: WIDGET.SPACE },
                                        ]);
                                        navigate(ROUTE.PAYMENT_CALLBACK, { collectionId: response.data.collectionId });
                                    }
                                });
                            };
                            const timer = setInterval(() => {
                                runPollar();
                            }, APP_CONFIG.POLLING_INTERVAL);
                        }
                        else {
                            if (isIframe() || isFromAndroidWebview()) {
                                showPopup({
                                    isAutoTriggerCta: true,
                                    type: 'DEFAULT',
                                    iconName: IconTokens.Redirecting,
                                    title: 'Waiting for response',
                                    subTitle: 'Please wait while we process your request',
                                    primary: false,
                                });
                                const url = res.data.paymentLink;
                                // Popup window size
                                const width = isFromTata ? 1002 : 504;
                                const height = 704;
                                // Calculate the position to center the popup on the screen
                                const left = (window.innerWidth - width) / 2;
                                const top = (window.innerHeight - height) / 2;
                                if (isFromAndroidWebview()) {
                                    popupWindow = window.open(url, "_blank");
                                }
                                else {
                                    popupWindow = window.open(url, "_blank", "width=" + width + ", height=" + height + ", top=" + top + ", left=" + left);
                                }
                            }
                            else {
                                if (isFromTata) {
                                    const tataPaymentLink = res.data.paymentLink;
                                    window.open(tataPaymentLink, "_self");
                                    setDatastore(ROUTE.OUTSTANDING_DUES, "manageLimit", {
                                        loading: false
                                    });
                                }
                                else {
                                    appendWidgets(ROUTE.PAYMENT_START, {
                                        repayLoanWebView: {
                                            iframe: Platform.OS === 'web',
                                            uri: res.data.paymentLink
                                        },
                                        keyboardSpace: { size: SizeTypeTokens.XXXXXXL },
                                        keyboardSpace2: { size: SizeTypeTokens.XXXXXXL },
                                        keyboardSpace3: { size: SizeTypeTokens.XXXXXXL },
                                    }, [
                                        { id: "repayLoanWebView", type: WIDGET.WEB_VIEW },
                                        { id: "keyboardSpace", type: WIDGET.SPACE },
                                        { id: "keyboardSpace2", type: WIDGET.SPACE },
                                        { id: "keyboardSpace3", type: WIDGET.SPACE },
                                    ], "header");
                                    removeWidgets(ROUTE.PAYMENT_START, [
                                        {
                                            id: "totalAmountShowStack",
                                            type: WIDGET.CARD,
                                            padding: {
                                                horizontal: 0,
                                                all: 0,
                                            },
                                            position: POSITION.ABSOLUTE_TOP,
                                        },
                                        {
                                            id: "spaceLG",
                                            type: WIDGET.SPACE
                                        },
                                        {
                                            id: "titleStack",
                                            type: WIDGET.STACK,
                                        },
                                        {
                                            id: "spaceXXXL",
                                            type: WIDGET.SPACE
                                        },
                                        {
                                            id: "selectFullAmountStack",
                                            type: WIDGET.STACK
                                        },
                                        {
                                            id: "spaceXXXL",
                                            type: WIDGET.SPACE
                                        },
                                        {
                                            id: "divider",
                                            type: WIDGET.DIVIDER
                                        },
                                        {
                                            id: "partialAmountFullStack",
                                            type: WIDGET.STACK
                                        },
                                        {
                                            id: "proceedButtonStack",
                                            type: WIDGET.STACK,
                                            position: POSITION.ABSOLUTE_BOTTOM
                                        },
                                        {
                                            id: "spaceLG",
                                            type: WIDGET.SPACE
                                        },
                                        { id: "enterAmountFullStack", type: WIDGET.STACK },
                                        { id: "amountMessage", type: WIDGET.TEXT }
                                    ]);
                                    setDatastore(ROUTE.OUTSTANDING_DUES, "header", {
                                        title: (isFromTata)
                                            ? (tataFlag
                                                ? "Paying to Tata Capital Limited"
                                                : "Paying to Tata Capital Financial Services Ltd.")
                                            : "Paying to Bajaj Finance"
                                    });
                                }
                            }
                            if (isIframe()) {
                                const runPollar = async () => {
                                    network.get(`${api.userPaymentData}${res.data.collectionId}`, { headers: await getAppHeader(), routeName: "PAYMENT_START" }, async () => { return; }, {
                                        disableDefault: true
                                    }).then((response) => {
                                        if (popupWindow.closed) {
                                            goBack();
                                            clearInterval(timer);
                                        }
                                        else {
                                            if (response.data.collectionStatus === 'COLLECTION_COMPLETE' || response.data.collectionStatus === 'CANCELLED' || response.data.collectionStatus === 'FAILED') {
                                                removeWidgets(ROUTE.PAYMENT_START, [
                                                    { id: "repayLoanWebView", type: WIDGET.WEB_VIEW },
                                                    { id: "keyboardSpace", type: WIDGET.SPACE },
                                                    { id: "keyboardSpace2", type: WIDGET.SPACE },
                                                    { id: "keyboardSpace3", type: WIDGET.SPACE },
                                                ]);
                                                clearInterval(timer);
                                                if (popupWindow) {
                                                    popupWindow.close(); // Close the popup window if it exists
                                                }
                                                navigate(ROUTE.PAYMENT_CALLBACK, { collectionId: response.data.collectionId });
                                            }
                                        }
                                    });
                                };
                                const timer = setInterval(() => {
                                    runPollar();
                                }, APP_CONFIG.POLLING_INTERVAL);
                            }
                        }
                    }
                    else {
                        setDatastore(ROUTE.OUTSTANDING_DUES, "manageLimit", {
                            loading: false
                        });
                    }
                });
            }
        }
        const creditStatus = await SharedPropsService.getCreditStatus();
        const user = await SharedPropsService.getUser();
        const isLoanExpired = await SharedPropsService.getIsLoanExpired();
        const totalOutstanding = parseInt(user.linkedCredits[0].principalOutStandingAmount) + user.linkedCredits[0].outstandingInterestDue || 0 + user.linkedCredits[0].chargesDue || 0 + user.linkedCredits[0].penalInterestDue || 0;
        const sanctionedLimit = user.linkedCredits[0].renewalDate;
        const requestOptions = {
            method: 'GET',
            headers: await getAppHeader(),
        };
        if (target && target === TARGET_PAGES.MANAGE_LIMIT) {
            removeUrlWithoutReload(QUERY_PARAMS.TARGET);
        }
        const creditResponse = await network
            .get(`${api.getForeclosureDetails}${user.linkedCredits[0].creditId}`, requestOptions);
        const showExcessAmountHandlingFlag = await showExcessAmountHandling(user);
        const creditAmount = user.linkedCredits[0].availableCreditAmount;
        const contactUsDetails = await getContactUsDetails();
        instrumentTrack('NET_PAYABLE_PAGE_VIEWED', {
            source_page: 'FORECLOSURE',
        });
        const platform = await sharedPropsService.getAppPlatform();
        const isFromJupiter = await SharedPropsService.getAppPlatform() === "JUPITER" /* AppPlatform.JUPITER */;
        return Promise.resolve(template(creditStatus, true, platform, getHeight(), creditResponse.data, creditAmount, sanctionedLimit, parseInt(totalOutstanding), user, contactUsDetails, isFromJupiter, showExcessAmountHandlingFlag, isLoanExpired));
    },
    actions: {
        [ACTION.EMAIL]: getURL,
        [ACTION.NAVIGATION]: navigation,
        [ACTION.MENU]: goBack,
        [ACTION.ENHANCE_LIMIT]: leadToPayment,
        [ACTION.MARGIN_CALL]: verifyOtp,
        [ACTION.NEED_HELP]: needHelp,
        [ACTION.EXCESS_AMOUNT_HANDLE]: excessAmountHandleAction,
        [ACTION.CANCEL_ACTION]: resetPage
    },
};
